<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Fecha Imputación"
          label-for="fechaImputacion"
          :label-cols="labelCols"
          description="Fecha de imputación para el cálculo de indicadores"
          horizontal>
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox 
                  id="fechaImputacionHabilitada"
                  v-model="fechaImputacionHabilitada"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-input-group-prepend>
            <b-form-input 
              id="fechaImputacion" 
              v-model="fechaImputacion" 
              type="date"
              :disabled="fechaImputacionDisabled">
            </b-form-input>
          </b-input-group>
        </b-form-group>
      </form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import moment from 'moment';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'VentasActualizacionFechaImputacion',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    ventaId: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      fechaImputacion: moment(new Date(1900, 1, 1)).format('YYYY-MM-DD'),
      fechaImputacionHabilitada: false,
      fechaImputacionDisabled: true,

      labelCols: 2,
    }
  },
  created() {
    this.showSpinner();
    this.$store.dispatch('ventas/getFechaImputacion', this.ventaId)
      .then(() => {
        this.fechaImputacion = this.$store.getters['ventas/fechaImputacion'];
        if (moment(this.fechaImputacion).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaImputacionHabilitada = false;
          this.fechaImputacionDisabled = true;
        } else {
          this.fechaImputacionHabilitada = true;
          this.fechaImputacionDisabled = false;
        }
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    save () {
      let fechaImputacion = '1900-01-01';
      if ((/true/i).test(this.fechaImputacionHabilitada)) {
        fechaImputacion = moment(this.fechaImputacion).format('YYYY-MM-DD');
      }

      let params = {
        ventaId: this.ventaId,
        fechaImputacion
      }
      this.showSpinner();
      this.$store.dispatch('ventas/actualizarFechaImputacion', params)
        .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.close, this.close, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    close() {
      this.$emit('closeActualizacion');
    },
  },
  watch: {
    'fechaImputacionHabilitada' : function(newVal, oldVal) {
      this.fechaImputacionDisabled = !(/true/i).test(this.fechaImputacionHabilitada);
    },
  }    
}
</script>

<style>
</style>
